export const GET_PORTER_QUOTE = "GET_PORTER_QUOTE";
export const GET_PORTER_QUOTE_LOADING = "GET_PORTER_QUOTE_LOADING";
export const GET_PORTER_QUOTE_ERROR = "GET_PORTER_QUOTE_ERROR";

